import {takeEvery} from 'redux-saga/effects'

import {
  ADD_BRANCH,
  CHECK_BRANCH_LIMIT,
  CONFIRM_BRANCH_BANNER_FILE_UPLOAD,
  CONFIRM_BRANCH_LOGO_FILE_UPLOAD,
  DELETE_BRANCH,
  DELETE_BRANCH_BANNER_FILE,
  DELETE_BRANCH_LOGO_FILE,
  GET_BRANCHES,
  GET_BRANCH_BANNER_SIGNED_UPLOAD_URL,
  GET_BRANCH_LOGO_SIGNED_UPLOAD_URL,
  UPDATE_BRANCH,
  VIEW_BRANCH,
} from '../../Actions/Branch/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_BRANCHES, fetchData)
  yield takeEvery(DELETE_BRANCH, fetchData)
  yield takeEvery(ADD_BRANCH, fetchData)
  yield takeEvery(VIEW_BRANCH, fetchData)
  yield takeEvery(UPDATE_BRANCH, fetchData)
  yield takeEvery(GET_BRANCH_LOGO_SIGNED_UPLOAD_URL, fetchData)
  yield takeEvery(CONFIRM_BRANCH_LOGO_FILE_UPLOAD, fetchData)
  yield takeEvery(GET_BRANCH_BANNER_SIGNED_UPLOAD_URL, fetchData)
  yield takeEvery(CONFIRM_BRANCH_BANNER_FILE_UPLOAD, fetchData)
  yield takeEvery(DELETE_BRANCH_LOGO_FILE, fetchData)
  yield takeEvery(DELETE_BRANCH_BANNER_FILE, fetchData)
  yield takeEvery(CHECK_BRANCH_LIMIT, fetchData)
}

export default dataSaga
